var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:brand-denodo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9998 11H12.9998V13H10.9998V11ZM3.63379 15.634L5.36579 14.634L6.36579 16.366L4.63379 17.366L3.63379 15.634ZM10.9998 19H12.9998V21H10.9998V19ZM18.6338 14.634L20.3658 15.634L19.3658 17.366L17.6338 16.366L18.6338 14.634ZM17.6338 7.634L19.3658 6.634L20.3658 8.366L18.6338 9.366L17.6338 7.634ZM10.9998 3H12.9998V5H10.9998V3ZM3.63379 8.366L4.63379 6.634L6.36579 7.634L5.36579 9.366L3.63379 8.366Z",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBran);
export default __webpack_public_path__ + "static/media/bran.8a14da2f51c5e023c40c3039b9d1a02e.svg";
export { ForwardRef as ReactComponent };